<template>
    <div class="step_content">
        <div class="operation_wrapper" style="padding-top: 0px">
            <h3 class="task-name-info">任务名称：<span :title="taskName">{{taskName}}</span></h3>
            <div class="titleBox">
                <h3 class="twoTitle">双随机抽取结果表</h3>
                <div class="noticeBtn">
                    <el-button type="text" @click="resultNoticeFn('2')" :disabled="alreadSend">通知执法检查人员</el-button>
                    <el-button type="text" @click="resultNoticeFn('1')" :disabled="alreadSend">通知项目主体</el-button>
                </div>
                <div class="twoTitleNav">
                    <span>抽取人员： <span>{{extractorName}}</span> </span>
                    <span>抽取完成时间： <span>{{extractTime}}</span> </span>
                </div>
            </div>
            <el-table stripe :data="tableData" v-loading="dataListLoading" class="bigScreenTable" :height="tableMaxHeight" border>
                <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="项目名称" prop='bidSectionName' header-align="center" align="left"
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="项目编号" prop='bidSectionCode' header-align="center" align="left"
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="项目类型" prop='projectTypeName' align="center"
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="合同金额" width='100'
                                 prop='contractMoney' align="center"
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{scope.row.contractMoney + '（元）' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="招标公告发布时间" prop='tenderBulletinDate' align="center" min-width='100'
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.tenderBulletinDate,'yyyy-MM-dd HH:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="合同签署时间" prop='contractSignDate' header-align="center" align="center" min-width='100'
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.contractSignDate,'yyyy-MM-dd HH:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="执法检查人员" prop='executorsIdsName' header-align="center" align="center" min-width='100'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" style="color: #00CCFF;" size="small" title="查看项目信息" @click="routerDetail(scope.row)">查看项目信息</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="btn_wraper" style="padding: 0px 24px">
            <p class="supervisionNameInfo" style="right:66px">监督检查单位：{{supervisionIdsName}}</p>
            <el-tooltip class="item" popper-class="bigScreenPopper" :visible-arrow="false" effect="light" placement="top-start">
                <div slot="content">
                    {{supervisionIdsName}}
                </div>
                <el-button type="text" style="float:right"> 更多> </el-button>
            </el-tooltip>
            <el-button plain >打印</el-button>
            <el-button @click="prevStep()" plain>上一步</el-button>
            <el-button type="primary" @click="handleClose()" plain >关闭</el-button>

        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    // import {removeTabHandle} from '@/utils/routeTab';
    export default {
        name: "step_six",
        components: {

        },
        props:{
            activeStep: {type: Number, default: 6},
            extractorName: {type: String, default: ''},
            extractTime: {type: String, default: ''},
            curStep: {type: Number, default: 6},
            historyid: {type: Number, default: -1},
            taskName: {type: String, default: ''},
            supervisionIdsName: {type: String, default: ''},
        },
        data(){
            return{
                id:"",
                alreadSend:false,
                cardMinHeight: document.documentElement.clientHeight - 350  + 'px',
                tableMaxHeight: document.documentElement.clientHeight - 550 ,
                dataListLoading:false,
                tableData:[],
                form:{
                    id:'',
                    historyid:'-1',
                    processinstanceid:"",
                },
                pageSize: 10,//每页条数
                pageIndex: 1,//当前页
                total: 0,//总条数
            }
        },
        filters:{

        },
        created(){
            this.form.taskId = this.$route.query.id || '';
            this.getExtractExectorList();

        },
        computed: {
            ...mapState({
                stateData:state=>state.user
            })
        },
        methods:{

            routerDetail(command){
                let paramMap = {
                    tenderProjectCode:command.tenderProjectCode || '',
                    bidSectionCode:command.bidSectionCode || '',
                    projectCode:command.projectCode || '',
                    bidSectionName:command.projectName || '',
                    applyCode:"",
                    idcard:"",
                }
                window.sessionStorage.setItem("witnessHisDetailParamMap",JSON.stringify(paramMap))
                removeTabHandle('businessWitnessHis_detail')
                this.$router.push({
                    name: "businessWitnessHis_detail",
                    params: { paramMap:paramMap },
                    query:{
                        businessType:command.businessType,
                        angleType:0,
                        purchaserMode:command.purchaserMode || '',

                    },
                });
            },

            getExtractExectorList(){
                // 获取选择执法人员和分组数
                this.$httpReq.get('/projectDoubleExtract/extracttask/extractResultList?taskId='+this.form.taskId).then(res=>{
                    if(res.data.code == '1' && res.data.data){
                        this.tableData = res.data.data
                    }else{
                        this.tableData = [];
                    }
                })
            },

            resultNoticeFn(type){

                this.$httpReq.get('/projectDoubleExtract/extracttask/sendMessage?extractTaskId='+this.form.taskId+'&sendType='+type).then(res=>{
                    if(res.data.code == '1'){
                        // this.alreadSend = true;
                        this.$message.success(res.data.msg)
                        return
                    }
                    this.$message.error(res.data.msg)
                })
            },

            handleClose(){
                removeTabHandle('project_extract_detail')
                this.$router.push({
                    name:'project_extract_list',
                })
            },

            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            prevStep(){
                this.$emit("update:activeStep",this.activeStep - 1)
            },
            nextStep(){
                this.$emit("update:activeStep",this.activeStep + 1)
            },

        },
    }
</script>

<style lang="scss" scoped>
    .step_content{
        opacity: 0.95;
        .operation_wrapper{
            border: none!important;
            background: none!important;
            padding-top:12px;
        }
        .titleBox{
            background: rgba(49, 150, 250, 0.25);
            padding: 18px 0 10px 0;
            position: relative;
            .twoTitle{
                width: 100%;
                font-size: 24px;
                line-height: 24px;
                font-family: FZZDHJW--GB1-0, FZZDHJW--GB1;
                font-weight: 600;
                color: white;
                margin: 0;
                padding: 0;
                text-align: center;
            }
            .noticeBtn{
                display: inline-block;
                position: absolute;
                left: 50%;
                margin-left:108px;
                top: 28px;
            }
            .twoTitleNav{
                display: flex;
                justify-content: space-between;
                padding: 0 12px;
                &>span{
                    display: inline-block;
                }
            }
        }
        /deep/ .el-table__header{
            background: rgba(49, 150, 250, 0.25);
        }
        /deep/ .el-table--border::after,/deep/ .el-table__fixed::before, /deep/ .el-table::before{
            background-color: rgba(49, 150, 250, 1) !important;
        }
    }

</style>